"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    var params = frame.params;
    // 回复响应帧
    virtual.send('devSyncResp', params);
    // 发送syncAction帧
    virtual.send(params && params.syncActio, params);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/devSync.ts